<template>
  <v-row>
    <v-col cols="12" sm="6" md="6" class="py-0 pr-sm-2">
      <v-text-field
        v-model="hookParentChild"
        :rules="passwordRules"
        :label="$t('password')"
        :prepend-inner-icon="mdiLockOutline"
        type="password"
        name="password"
        class="body-2"
        placeholder=" "
        outlined
        required
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="6" class="py-0 pl-sm-2">
      <v-text-field
        v-model="passwordConfirmation"
        :rules="passwordConfirmationRules"
        :label="$t('password-confirm')"
        :prepend-inner-icon="mdiLockOutline"
        type="password"
        class="body-2"
        placeholder=" "
        validate-on-blur
        outlined
        required
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { mdiLockOutline } from "@mdi/js";
import XRegExp from "xregexp";

export default {
  name: "ConfirmablePassword",
  data: vm => ({
    mdiLockOutline: mdiLockOutline,
    password: "",
    passwordRules: [
      v => !!v || vm.$t("field-requied"),
      v =>
        XRegExp(
          "^(?=.*\\p{Ll})(?=.*\\p{Lu})(?=.*[0-9])(?=.*[ -/:-@\\[-`{-~]).{6,64}$"
        ).test(v) || vm.$t("password-invalid")
    ],
    passwordConfirmation: ""
  }),
  computed: {
    passwordConfirmationRules() {
      return [
        this.password === this.passwordConfirmation ||
          this.$i18n.t("password-mismatch")
      ];
    },
    hookParentChild: {
      get() {
        return this.password;
      },
      set(password) {
        this.password = password;
        this.$emit("setFormValue", password);
      }
    }
  }
};
</script>
